<template>
  <form-dialog
    ref="form"
    :applyButtonText="$t('Save')"
    class="user-change-password v-change-password"
    :errors="otherErrors"
    :model="form"
    :pending="pending"
    :rules="rules"
    :submit="onSubmit"
    :title="$t('Change password')"
    visible
    @close="close"
  >
    <div class="pt-24 mx-24">
      <el-form-item
        :error="errors.current_password"
        prop="current_password"
      >
        <el-password
          v-model="form.current_password"
          :label="$t('Current password')"
          with-icon
        />
      </el-form-item>

      <el-form-item
        :error="errors.new_password"
        prop="new_password"
      >
        <el-password
          v-model="form.new_password"
          :label="$t('New password')"
          with-icon
        />
      </el-form-item>

      <el-form-item prop="confirm_password">
        <el-password
          v-model="form.confirm_password"
          :label="$t('Confirm password')"
          with-icon
        />
      </el-form-item>
    </div>
  </form-dialog>
</template>

<script>
  import FormDialog from '@/common/shared/FormDialog.vue';
  import { confirmPasswordRule, newPasswordRules, passwordRule } from '@/common/validation/authRules';
  import { mapState, mapStores } from 'pinia';
  import useAuthStore from '@/common/store/pinia/auth';

  export default {
    name: 'UserChangePassword',
    components: {
      FormDialog
    },
    data() {
      return {
        pending: false,
        form: {
          current_password: '',
          new_password: '',
          confirm_password: ''
        },
        errors: {},
        otherErrors: []
      };
    },
    computed: {
      ...mapStores(useAuthStore),
      ...mapState(useAuthStore, ['currentUser']),
      rules() {
        const { current_password: currentPassword, new_password: newPassword } = this.form;
        const validateCallback = () => this.$refs.form.validateField('confirm_password');
        return {
          current_password: passwordRule(),
          new_password: newPasswordRules({ currentPassword, validateCallback }),
          confirm_password: confirmPasswordRule({ newPassword })
        };
      },
    },
    methods: {
      onSubmit() {
        this.errors = [];
        this.pending = true;

        return this.authStore.changePassword(this.form)
          .then(() => this.authStore.signIn({
            username: this.currentUser.name,
            password: this.form.new_password
          }))
          .then(() => {
            this.pending = false;
            this.close();

            this.$notify.success({
              message: this.$root.$t('Password successfully changed')
            });
          })
          .catch((err) => {
            this.pending = false;
            if (err.fields) {
              this.errors = err.fields;
            } else {
              this.otherErrors = [err.message];
            }
          });
      },
      close() {
        this.$emit('close');
      }
    }
  };
</script>
